const routes = [

	
	//---- Test
	{ 
		path: '/developers/test', 
		name: "test-index", 
		component: () => import("/developers/test/index.vue"),
		meta: { layout: "no", layoutType: "", isPublic: true, pageTitle: "Test E" } 
		//meta: { layout: "public", layoutType: "default", isPublic: true, pageTitle: "Test B" } 
		//meta: { layout: "primary", layoutType: "default", layoutContainer: "none", isPublic: true, pageTitle: "Test C", kbFile: "home", kbTitle: "Test C" } 
	},
	{ 
		path: '/developers/test/simple-form', 
		name: "test-simple-form", 
		component: () => import("/developers/test/simple-form.vue"),
		meta: { layout: "primary", layoutType: "", isPublic: true, module: "developers", parentRouteName: "test-index", pageTitle: "Test Simple Form Renderer" }
	},
	{ 
		path: '/developers/test/simple-table', 
		name: "test-simple-table", 
		component: () => import("/developers/test/simple-table.vue"),
		meta: { layout: "primary", layoutType: "", isPublic: true, module: "developers", parentRouteName: "test-index", pageTitle: "Test Simple Table Renderer" }
	},
		{ 
		path: '/developers/test/simple-data-editor', 
		name: "test-simple-data-editor", 
		component: () => import("/developers/test/simple-data-editor.vue"),
		meta: { layout: "primary", layoutType: "", isPublic: true, module: "developers", parentRouteName: "test-index", pageTitle: "Test Simple Data Editor" }
	},




	{
		path: '/developers/test/unsaved-changes',
		name: "test-unsaved-changes",
		component: () => import("/developers/test/unsaved-changes.vue"),
		meta: { layout: "primary", layoutType: "", isPublic: true, module: "developers", parentRouteName: "test-index", pageTitle: "Test Unsaved Changes Guard" }
	},


	{
		path: '/developers/test/page-title',
		name: "test-page-title",
		component: () => import("/developers/test/page-title.vue"),
		meta: { layout: "primary", layoutType: "", isPublic: true, module: "developers", parentRouteName: "test-index", pageTitle: "Test Page Title - {clientName}" }
	},


	{
		path: '/developers/test/generate-error',
		name: "test-generate-error", 
		component: () => import("/developers/test/generate-error.vue"),
		meta: { layout: "no", layoutType: "", isPublic: true, module: "developers", parentRouteName: "", pageTitle: "Rollbar Error Logging" }
	},


	{ 
		path: '/developers/test/chatgpt/table2', 
		name: "test-chatgpt-table2", 
		component: () => import("/developers/test/chatgpt/table2-host.vue"),
		meta: { layout: "primary", layoutType: "", isPublic: true, module: "developers", parentRouteName: "test-index", pageTitle: "Table 2" }
	},

]


export default routes;